//export const apiRoot = 'https://duendeidentityserverdemo20240116160441.azurewebsites.net/api/';
// const baseURL = "http://localhost:3000/"; //https://tptmemberportal.wipro.com/
// const env = "dev"; // dev, qa, uat
//in local
//http://localhost:3000/signin-callback.html
//in dev
//https://tptmemberportal.wipro.com/dev/
//in qa
//https://tptmemberportal.wipro.com/qa/
//in uat
//https://my-uat.tpt.co.uk/uat/
//in preprod
//https://my-preprod.tpt.co.uk/
//in prod
//https://my.tpt.co.uk/
const oidcConfig = {
  authority: process.env.REACT_APP_TPT_SSO_AUTHORITY,
  client_id: process.env.REACT_APP_TPT_SSO_CLIENT_ID,
  client_secret: process.env.REACT_APP_TPT_SSO_CLIENT_SECRET,
  redirect_uri: process.env.REACT_APP_TPT_SSO_REDIRECT_URL,
  silent_redirect_uri: process.env.REACT_APP_TPT_SSO_SILENT_REDIRECT_URL,
  post_logout_redirect_uri:
    process.env.REACT_APP_TPT_SSO_POST_LOGOUT_REDIRECT_URL,
  response_type: "code",
  scope: process.env.REACT_APP_TPT_SSO_SCOPE,
  checkSessionInterval: 5000,
};
if (
  process.env.REACT_APP_ENV === "uat" ||
  process.env.REACT_APP_ENV === "preprod" ||
  process.env.REACT_APP_ENV === "prod"
) {
  delete oidcConfig.client_secret;
}
export default oidcConfig;
